import React from 'react';
import Index from './Index';
import TrialBalanceView from '../components/views/TrialBalanceView';
import { modules } from '../config/const';

function TrialBalancePage() {
  return <Index content={TrialBalanceView} module={modules.TrialBalance} />;
}

export default TrialBalancePage;
